<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Lesson Plan Details</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <a
            href="javascript:;"
            class="btn btn-sm btn-dark btn-with-addon"
            @click="handleBackButton"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-chevron-left" />
            </span>
            Back
          </a>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <p class="text-muted">
              View lesson plan structure and update topic progress.
            </p>
            <!-- The child component does all the heavy lifting -->
            <display-lesson-plan />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplayLessonPlan from '@/components/teacherprogress/lessonPlanDetails/index'

export default {
  name: 'LessonPlanDetails',
  components: {
    DisplayLessonPlan,
  },
  methods: {
    handleBackButton() {
      // Navigates back to the main list page
      this.$router.push({ name: 'teacherprogresslog' })
    },
  },
}
</script>
